import type { Language } from '@carbonara/translations'
import { format } from 'date-fns'
import { enUS, nb } from 'date-fns/locale'

type Options = Parameters<typeof format>[2]

export const formatDate = (
	date: number | Date,
	formatStr: string,
	language: Language = 'nb',
	options?: Options,
) => {
	try {
		return format(date, formatStr, {
			locale: language === 'en' ? enUS : nb,
			...options,
		}).toUpperCase()
	} catch (e) {
		console.error(e)
		console.error(date)
		return 'Invalid date'
	}
}
